import { z } from 'zod'
import { listRequestDataSchema } from './list-request-data'

/**
 * 角色 - 查詢多筆 Request Schema
 */
export const getRoleListRequestSchema = listRequestDataSchema.merge(
  z.object({
    /** 角色名稱關鍵字 */
    q: z.string().optional(),
    /** 角色類型 */
    roleClass: z.array(z.string()).optional()
  })
)

/**
 * 角色 - 查詢多筆 Request
 */
export interface GetRoleListRequest
  extends z.infer<typeof getRoleListRequestSchema> {}
